import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";
import { Button } from "../components/ui/button";

// Logo URL
const LOGO_URL = "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/ww3ixl6i_Logo%20Tienda%20Ecolo%CC%81gica%20Minimalista%20Beige%20%281%29.png";

// Phone numbers
const PHONE_NUMBERS = ["913-415-9619", "817-939-1605"];

// Gallery images - SEO-optimized alt text with location keywords
const GALLERY_IMAGES = [
  // Tree Work
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/6izksjfr_2937469907864273101.jpeg", category: "Tree Work", alt: "Tree removal project in Kansas City by German Sorto Tree Service" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/1sgjjaje_5744291385490736081.jpeg", category: "Tree Work", alt: "Professional tree trimming service in Overland Park KS" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/so3pswfo_6931565895204421695.jpeg", category: "Tree Work", alt: "Large tree trimming project Kansas City metro area" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_sorto-tree-kc/artifacts/bukbtrpe_IMG_5870.webp", category: "Tree Work", alt: "Certified arborist climbing tree for removal Kansas City" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_sorto-tree-kc/artifacts/p6p6qw7b_IMG_5869.webp", category: "Tree Work", alt: "Professional tree trimming and pruning service Kansas City" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_sorto-tree-kc/artifacts/deuv6x8q_IMG_5868.webp", category: "Tree Work", alt: "Mature oak tree pruning Kansas City metro" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_sorto-tree-kc/artifacts/777oo68p_IMG_5874.webp", category: "Tree Work", alt: "Backyard tree trimming and crown thinning Kansas City" },
  // Landscaping
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/8n0d2w1i_7712207353650773321.jpeg", category: "Landscaping", alt: "Landscaping installation with mulch bed Kansas City" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/nkzkbe93_2440954151375269199.jpeg", category: "Landscaping", alt: "Tree ring with paver stones landscaping Olathe" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/9z3giedu_7395903022357980789.jpeg", category: "Landscaping", alt: "Flower bed and shrub landscaping design Lenexa KS" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/kcjf7xb0_2946841483716020746.jpeg", category: "Landscaping", alt: "Red mulch landscaping project Kansas City" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_sorto-tree-kc/artifacts/z4kknvlm_1000017061.webp", category: "Landscaping", alt: "Professional lawn care and mowing service Kansas City" },
  // Concrete
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/bb96392x_2666299620353767973.jpeg", category: "Concrete", alt: "Stamped concrete patio installation Kansas City" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/0du2b6an_963157893840751684.jpeg", category: "Concrete", alt: "Custom concrete floor installation Shawnee KS" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/pbm7scua_5407837736555581475.jpeg", category: "Concrete", alt: "Stamped concrete patio design Lee's Summit MO" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/15b893xx_168536642987948694.jpeg", category: "Concrete", alt: "Commercial concrete sidewalk Kansas City" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/tqoj0hte_5479039266396650928.jpeg", category: "Concrete", alt: "Stamped concrete driveway Independence MO" },
  // Fences
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/a90gotw8_2466655734892600536.jpeg", category: "Fences", alt: "Wood privacy fence installation Overland Park Kansas" },
  { src: "https://customer-assets.emergentagent.com/job_sorto-tree-kc/artifacts/hqckblo3_9059601336893746541.jpeg", category: "Fences", alt: "Custom wood deck construction Kansas City" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_sorto-tree-kc/artifacts/6cjs6ciz_1000016666.webp", category: "Fences", alt: "Black metal wrought iron fence installation Kansas City" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_sorto-tree-kc/artifacts/4m8f95fs_1000016922.webp", category: "Fences", alt: "Wrought iron fence with concrete base Kansas City" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_sorto-tree-kc/artifacts/kg9wefrf_1000017064.webp", category: "Fences", alt: "Metal fence installation with soil preparation Kansas City" },
  // Retaining Walls
  { src: "https://images.unsplash.com/photo-1761637823941-0ffae96ec487?w=800", category: "Retaining Walls", alt: "Stone retaining wall construction Kansas City area" }
];

const GalleryPage = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  const categories = ["All", "Tree Work", "Landscaping", "Concrete", "Fences", "Retaining Walls"];

  const filteredImages = activeFilter === "All" 
    ? GALLERY_IMAGES 
    : GALLERY_IMAGES.filter(img => img.category === activeFilter);

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="bg-card border-b border-white/5 py-4 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src={LOGO_URL} 
                alt="German Sorto Tree Service" 
                className="h-20 md:h-24 w-auto"
              />
              <div className="hidden sm:block">
                <h1 className="text-lg md:text-2xl font-bold text-white uppercase tracking-wide leading-tight">
                  German Sorto
                </h1>
                <p className="text-xs md:text-sm text-accent uppercase tracking-widest">Tree Service</p>
              </div>
            </Link>

            <div className="flex items-center gap-4">
              <div className="hidden md:flex flex-col items-end">
                <a href={`tel:${PHONE_NUMBERS[0].replace(/-/g, '')}`} className="text-white font-semibold">
                  {PHONE_NUMBERS[0]}
                </a>
                <a href={`tel:${PHONE_NUMBERS[1].replace(/-/g, '')}`} className="text-white/70 text-sm">
                  {PHONE_NUMBERS[1]}
                </a>
              </div>
              <a href={`tel:${PHONE_NUMBERS[0].replace(/-/g, '')}`}>
                <Button className="bg-accent text-black hover:bg-accent/90 font-bold uppercase tracking-wider">
                  <Phone className="w-4 h-4 mr-2" />
                  Call Now
                </Button>
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Back Link */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-white/60 hover:text-accent transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
      </div>

      {/* Gallery Section */}
      <section className="pb-20 md:pb-32">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* Section Header */}
          <div className="mb-12">
            <div className="w-16 h-1 bg-accent mb-4"></div>
            <h1 className="text-4xl md:text-6xl font-bold text-white uppercase tracking-tight mb-4">
              Tree Service & Landscaping Portfolio | Kansas City
            </h1>
            <p className="text-white/60 text-lg max-w-2xl">
              Browse our portfolio of completed tree removal, landscaping, concrete, and fence projects across the Kansas City metro area. 
              Quality workmanship in Overland Park, Olathe, Lee's Summit, and beyond.
            </p>
          </div>

          {/* Filter Tabs */}
          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveFilter(category)}
                className={`px-5 py-2.5 rounded-sm font-medium transition-all ${
                  activeFilter === category 
                    ? 'bg-accent text-black' 
                    : 'bg-white/5 text-white/70 hover:bg-white/10 hover:text-white'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Gallery Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {filteredImages.map((image, index) => (
              <div 
                key={index} 
                className="group relative aspect-[4/3] rounded-sm overflow-hidden border border-white/5"
              >
                <img 
                  src={image.src} 
                  alt={image.alt}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <span className="text-accent text-sm font-medium">{image.category}</span>
                    <p className="text-white font-semibold">{image.alt}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-16 text-center">
            <p className="text-white/60 mb-4">Like what you see? Let's discuss your project.</p>
            <a href={`tel:${PHONE_NUMBERS[0].replace(/-/g, '')}`}>
              <Button className="bg-accent text-black hover:bg-accent/90 font-bold uppercase tracking-wider px-8 py-6 text-lg">
                <Phone className="w-5 h-5 mr-2" />
                Call for Free Estimate
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 bg-[#050705] border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} German Sorto Tree Service. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default GalleryPage;
